import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  type: "All",
  search: "",
  sortOption: "",
};

const filterSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    changeType: (state, action) => {
      state.type = action.payload;
    },
    changeSeatchText: (state, action) => {
      state.search = action.payload;
    },
    changeSortOption: (state, action) => {
      state.sortOption = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const { changeType, changeSeatchText, changeSortOption } =
  filterSlice.actions;
